// Shared loading state shown while pages fetch their data.
// 'fullScreen' is used by the Survey page which has no sidebar layout.
export default function LoadingSpinner({ fullScreen = false }: { fullScreen?: boolean }) {
  const wrapper = fullScreen
    ? 'min-h-screen bg-slate-50 flex items-center justify-center'
    : 'flex items-center justify-center h-64'

  return (
    <div className={wrapper}>
      <div className="flex flex-col items-center gap-3">
        <div className="w-8 h-8 border-[3px] border-slate-200 border-t-[#005EB8] rounded-full animate-spin" />
        <span className="text-sm text-slate-400 font-medium">Loading...</span>
      </div>
    </div>
  )
}
